module.exports = __webpack_public_path__ + "./fonts/GTAmerica-CompressedRegular.otf";